<script lang="ts" setup>
import { computed, ref } from '#imports'
import DownIcon from '@/components/icons/ArrowDownIcon.vue'
import GridViewIcon from '@/components/icons/GridViewIcon.vue'
import ListViewIcon from '@/components/icons/ListViewIcon.vue'
import WaterfallIcon from '@/components/icons/WaterfallIcon.vue'
import { useLayout } from '@/store/layout'
import { type Component } from 'vue'
import ViewTypeBase from '~/components/share/ViewTypeBase.vue'
import useDisplayMode from '~/composables/useDisplayMode'
import { ViewType } from '~/types/enum'

const iconMap: { [key in ViewType]?: Component } = {
  [ViewType.GRID]: GridViewIcon,
  [ViewType.LIST]: ListViewIcon,
  [ViewType.FLOW]: WaterfallIcon,
}
const layoutStore = useLayout()

const isMobile = computed(() => layoutStore.isMobile)

const popoverRef = ref()
const { viewType } = useDisplayMode()

const handleViewTypeChange = () => popoverRef.value?.hide()
</script>

<template>
  <ElPopover
    ref="popoverRef"
    placement="bottom"
    trigger="click"
    popper-class="view-type-popper"
    width="auto"
  >
    <template #reference>
      <div class="view-type-switch-button">
        <!-- current view mode icon -->
        <component
          :is="iconMap[viewType]"
          :hover-able="!isMobile"
        />
        <DownIcon :hover-able="!isMobile" />
      </div>
    </template>
    <ViewTypeBase @change="handleViewTypeChange" />
  </ElPopover>
</template>

<style lang="less">
.view-type-switch-button {
  display: flex;
  cursor: pointer;
  height: 36px;
  align-items: center;
  margin-left: 24px;
}

.view-type-popper {
  min-width: unset !important;
  width: auto;
}

@media screen and (max-width: 768px) {
  .el-popover.el-popper.view-type-popper {
    padding: 8px;
  }
}
</style>
